import moment from 'moment';
import { Loader } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Employee, Order, Session, Trip } from 'service';
import ArthaGateway from 'service/ArthaGateway';
import { RootState } from 'store/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faCircle, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { BarcodeScanner, DetectedBarcode, useTorch } from 'react-barcode-scanner'
import 'react-barcode-scanner/polyfill'
import toast, { Toaster } from 'react-hot-toast';
import truck_front from '../../assets/truck/truck_front.png';
import truck_back from '../../assets/truck/truck_back.png';
import truck_center from '../../assets/truck/truck_center.png';
import swal from 'sweetalert';

export const Loading = () => {
    const appdata = useSelector((state: RootState) => state.appdata);
    const [session, setSession] = useState<Employee>();
    const [trips, setTrips] = useState<any[]>([]);
    const [trip, setTrip] = useState<Trip>();
    const [tripId, setTripId] = useState<number>(0);
    const [totalPackages, setTotalPackages] = useState<number>(0);
    const [scannedPackages, setScannedPackages] = useState<number>(0);
    const [packageNumbers, setPackageNumbers] = useState<any[]>([]);
    const [orderId, setOrderId] = useState<number>(0);
    const [order, setOrder] = useState<Order>();
    const [packageNumber, setPackageNumber] = useState<string>('');
    const [screen, setScreen] = useState<string>('selectTrip');
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isTripLoading, setIsTripLoading] = useState<boolean>(false);
    const [isOrderLoading, setIsOrderLoading] = useState<boolean>(false);
    const [showVehicleDetails, setShowVehicleDetails] = useState<boolean>(true);
    const paymentAmountRef = useRef<null | HTMLInputElement>(null);
    const barcodeRefRef = useRef<null | HTMLInputElement>(null);
    const audioRef = useRef<HTMLAudioElement>(null);
    const [vehicleNumber, setVehicleNumber] = useState<string>('');
    const [driverName, setDriverName] = useState<string>('');
    const [driverNumber, setDriverNumber] = useState<string>('');
    const [productionPlants, setProductionPlants] = useState<any[]>([]);
    const [selectedProductionPlantId, setSelectedProductionPlantId] = useState<number>(0);

    useEffect(() => {
        if (appdata.profile) {
            setSession(appdata.profile.profile);
        }
    }, [appdata]);

    useEffect(() => {
        console.log(session);
        if (session) {
            loadTrips();
            loadProductionPlants();
        }
    }, [session]);

    useEffect(() => {
        if (tripId > 0) {
            loadTrip(tripId);
        }
    }, [tripId]);

    useEffect(() => {
        if (orderId > 0) {
            loadOrder(orderId);
        }
    }, [orderId]);

    useEffect(() => {
        if (productionPlants.length > 0 && selectedProductionPlantId <= 0) {
            const defaultPlant = productionPlants[0];
            const defaultPlantId = Number(defaultPlant?.id ?? defaultPlant?.plantId ?? 0);
            setSelectedProductionPlantId(defaultPlantId);
        }
    }, [productionPlants, selectedProductionPlantId]);
    
    const loadProductionPlants = () => {
        let cachedPlants = sessionStorage.getItem("production_plants");
        if(cachedPlants) {
            setProductionPlants(JSON.parse(cachedPlants));
            return;
        }
        let employeeId = session?.id;
        if(employeeId && employeeId > 0) {
            ArthaGateway
                .getProductionPlants(employeeId)
                .then((data) => {
                    sessionStorage.setItem("production_plants", JSON.stringify(data));
                    setProductionPlants(data);
                })
                .catch((error) => {
                    console.error("Error loading production plants:", error);
                });
        }
        setIsLoading(true);
    }

    const loadTrips = () => {
        setIsLoading(true);
        setScreen('selectTrip');
        // trip status 3 = Assigned
        ArthaGateway
            .getTrips("9", 3)
            .then((data) => {
                setTrips(data.entries);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const selectTrip = (trip) => {
        setTripId(trip.id);
        setVehicleNumber(trip.vehicleNumber);
        setDriverName(trip.driverName);
        setDriverNumber(trip.driverNumber);
        setScreen('selectOrder');
    }

    const loadTrip = (tripId) => {
        setIsTripLoading(true);
        ArthaGateway
            .getTrip(tripId)
            .then((data) => {
                data.details.forEach((detail, index) => {
                    detail.isOrderLoaded = false;
                });

                setTrip(data);
                setIsTripLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadOrder = (orderId) => {
        setIsOrderLoading(true);
        setScreen('loadOrder');
        ArthaGateway
            .getOrder(orderId)
            .then((data) => {
                updateAsCurrentOrder(data);
            })
            .catch(error => {
                console.log(error);
                setIsOrderLoading(false);
            });
    }

    const updateAsCurrentOrder = (order) => {
        order.items.forEach((item) => {
            item.loadingDetails.currentLoading = item.quantity - (item.loadingDetails.loadedQuantity || 0);
        });

        let detail = trip?.details.find((detail) => detail.order.id === order.id);
        if (detail) {
            detail.order = order;
            detail.isOrderLoaded = true;
            setTrip(trip);
        }
        setOrder(order);
        setIsOrderLoading(false);
    }

    const toggleExapnd = (target) => {
        if (!trip) return;
        trip?.details.map((request) => {
            if (request.id === target.id) {
                request.isExpanded = !request.isExpanded;
            }
            else {
                request.isExpanded = false;
            }
        });
        setTrip(trip);
    }

    const completeLoading = () => {
        if (!trip) return;

        swal({
            title: "Are you sure?",
            text: "Are you sure you want to mark trip as loaded?",
            icon: "warning",
            dangerMode: true,
            buttons: [
                'No, I am not sure',
                'Yes, I am sure!'
            ],
        })
            .then((isConfirmed) => {
                if (isConfirmed) {
                    ArthaGateway
                        .markTripAsLoaded(trip.id)
                        .then((data) => {
                            setTripId(0);
                            loadTrips();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
    }

    const onBarcodeCaptured = (barcodes: DetectedBarcode[]) => {
        if (!trip) return;
        if (screen === 'scanBarcode') {
            setScreen('selectOrder');
        }

        setTimeout(() => {
            barcodes.map((barcode) => {
                //handlePackageNumber(barcode.rawValue.trim());
            });
        }, 500);
    }

    const playAudio = (textToPlay) => {
        const speechSynth = window.speechSynthesis;
        if (textToPlay.trim().length) {
            let voices = speechSynthesis.getVoices();
            let indianVoice = voices.find((voice) => voice.lang === 'kn-IN');
            if (!indianVoice) {
                indianVoice = voices.find((voice) => voice.lang === 'hi-IN');
            }
            const newUtter =
                new SpeechSynthesisUtterance(textToPlay);
            if (indianVoice) {
                newUtter.voice = indianVoice;
                newUtter.lang = 'hi-IN';
            }
            speechSynth.speak(newUtter);
        }
    }

    const markAsLoaded = (item) => {
        if (!trip || !order) return;

        if (!item.loadingDetails.currentLoading || item.loadingDetails.currentLoading <= 0) {
            toast.error("Please enter loaded quantity");
            return;
        }

        item.loadingDetails.loadedBy = session?.id || 0;
        item.loadingDetails.loadedQuantity = item.loadingDetails.currentLoading;

        setIsOrderLoading(true);
        ArthaGateway.markPackageAsLoaded(item.loadingDetails)
            .then((data) => {
                toast.success("Marked as loaded");
                updateAsCurrentOrder(data);
            })
            .catch(error => {
                console.log(error);
                toast.error("Failed to mark as loaded");
                setIsOrderLoading(false);
            });
    }

    const convertKgToTon = (kilograms) => {
        if (typeof kilograms !== 'number' || isNaN(kilograms)) {
            return 'Invalid input';
        }

        // 1 ton = 1000 kg
        const tons = kilograms / 1000;

        // Use .toFixed(2) to format the number to exactly two decimal places.
        // This method returns a string representation.
        return tons.toFixed(2);
    }

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    const getDeliveryStatusText = (statusValue) => {
        const statusMap = {
            1: 'Pending',
            2: 'TripAssigned',
            3: 'Loading',
            4: 'Loaded',
            5: 'TripStarted',
            6: 'Deliverd'
        };

        if (typeof statusValue === 'number') {
            return statusMap[statusValue] || statusValue.toString();
        }

        const numericStatus = Number(statusValue);
        if (!Number.isNaN(numericStatus) && statusMap[numericStatus]) {
            return statusMap[numericStatus];
        }

        return statusValue || 'Pending';
    }

    const isLoadedDeliveryStatus = (statusValue) => {
        return getDeliveryStatusText(statusValue).toLowerCase() === 'loaded';
    }

    return (
        <div className='page page-accounts'>
            <div><Toaster /></div>
            <audio id="alarm_sound" ref={audioRef} src="alarm.mp3" preload="auto"></audio>
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    {screen === 'selectTrip' &&
                        <>
                            <h1>Select Trip</h1>
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <ul className="list-group">
                                        {(!trips || trips.length == 0) &&
                                            <li className="list-group-item"><div className='alert alert-danger w-100'>No trips are assigned to any order, Please refresh again once trips are assigned</div></li>
                                        }
                                        {trips && trips.map((trip) => (
                                            <li className="list-group-item align-items-center" key={trip.id} onClick={() => selectTrip(trip)}>
                                                <div className="float-start">
                                                    <h2 className="fw-bold">{trip.vehicleNumber}</h2>
                                                    <div>{trip.name}</div>
                                                </div>
                                                <div className="btn btn-sm btn-dark float-end">Select</div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </>
                    }
                    {screen === 'selectOrder' &&
                        <>
                            {isTripLoading &&
                                <Loader />
                            }
                            {!isTripLoading &&
                                <>
                                    {(trip && trip.details.length > 0) &&
                                        <>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='page-header bg-dark' style={{ paddingBottom: "10px", marginBottom: "10px" }}>
                                                        <div className="fw-bold">{trip?.name}</div>
                                                        <div>No: {trip?.voucherNumber}</div>
                                                        <div>Vehicle: <b>{trip.vehicleNumber}</b></div>
                                                        <div>Driver: <b>{trip.driverName}</b> ({trip.driverNumber})</div>
                                                        <div><b>{convertKgToTon(trip?.details.reduce((acc, detail) => acc + detail.order.totalWeight, 0))}</b> tons<br /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div>
                                        <img src={truck_front} alt="Truck Front" />
                                    </div>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className="d-flex flex-column gap-2">
                                                {(!trip || trip.details.length == 0) &&
                                                    <div className='alert alert-danger w-100'>No orders are assigned to this trip, Please refresh again once orders are assigned</div>
                                                }
                                                {trip && trip.details.map((detail) => (
                                                    <div key={detail.id} className={isLoadedDeliveryStatus(detail.order.deliveryStatus) ? "card border-success bg-success bg-opacity-10" : "card border-danger bg-danger bg-opacity-10"} style={{ cursor: 'pointer' }} onClick={() => setOrderId(detail.order.id)}>
                                                        <div className="card-body py-2 px-3">
                                                            <div className="d-flex justify-content-between align-items-start gap-2">
                                                                <div>
                                                                    <div>
                                                                        # <span className="fw-bold" style={{ color: "red" }}>{detail.order.voucherNumber}</span>
                                                                        <span className={isLoadedDeliveryStatus(detail.order.deliveryStatus) ? "badge bg-success ms-2" : "badge bg-danger ms-2"}>
                                                                            {getDeliveryStatusText(detail.order.deliveryStatus)}
                                                                        </span>
                                                                    </div>
                                                                    <div className="mt-1">
                                                                        {detail.order.partyName || detail.order.party.name }<br />
                                                                        <div><b>{detail.order.shippingCity} - {detail.order.shippingPinCode}</b></div>
                                                                        <b>{convertKgToTon(detail.order.totalWeight)}</b> tons<br />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <img src={truck_back} alt="Truck Back" />
                                    </div>
                                </>
                            }
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <div className="btn btn-sm btn-danger float-start" onClick={() => setScreen('selectTrip')}>Back</div>
                                </div>
                            </div>
                        </>
                    }
                    {screen === 'loadOrder' &&
                        <>
                            {isOrderLoading &&
                                <Loader />
                            }
                            {!isOrderLoading &&
                                <>
                                    {(order && order.items.length > 0) &&
                                        <>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    {/* Order Summary Header */}
                                                    <div className="card mb-3" style={{ borderLeft: '4px solid #495057' }}>
                                                        <div className="card-body py-2 px-3">
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div>
                                                                    <div className="text-muted small mb-1">Sales Order</div>
                                                                    <div className="fw-bold fs-5">{order?.voucherNumber}</div>
                                                                    <div className="mt-1">{order?.party.name}</div>
                                                                    <div className="small text-muted">{order?.shippingCity}{order?.shippingPinCode ? ` – ${order?.shippingPinCode}` : ''}</div>
                                                                </div>
                                                                <div className="text-end">
                                                                    <span className={isLoadedDeliveryStatus(order?.deliveryStatus) ? 'badge bg-success mb-1' : 'badge bg-danger mb-1'} style={{ fontSize: '0.8rem', padding: '5px 10px' }}>
                                                                        {getDeliveryStatusText(order?.deliveryStatus)}
                                                                    </span>
                                                                    <div className="small text-muted mt-1">{convertKgToTon(order?.totalWeight)} tons</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row mb-2'>
                                                <div className='col-12 col-md-6'>
                                                    <label htmlFor="productionPlant" className="form-label small text-muted mb-1">Production Plant</label>
                                                    <select
                                                        id="productionPlant"
                                                        className="form-select form-select-sm"
                                                        value={selectedProductionPlantId}
                                                        onChange={(e) => setSelectedProductionPlantId(Number(e.target.value))}
                                                    >
                                                        {productionPlants.length === 0 &&
                                                            <option value={0}>No production plants found</option>
                                                        }
                                                        {productionPlants.length > 0 && productionPlants.map((plant, idx) => {
                                                            const plantId = Number(plant?.id ?? plant?.plantId ?? idx);
                                                            const plantName = plant?.name || plant?.plantName || `Plant ${plantId}`;
                                                            return (
                                                                <option key={plantId} value={plantId}>{plantName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div className='row'>
                                        <div className='col-12'>
                                            {order && order.items && order.items.length > 0 ? (
                                                <div className="d-flex flex-column gap-2">
                                                    {order.items.map((item, index) => {
                                                        const isLoaded = item.loadingDetails && Number(item.loadingDetails.loadedQuantity) > 0;
                                                        const itemPlantId = Number((item.product as any)?.plantId || 0);
                                                        const isPlantMatched = selectedProductionPlantId > 0 && itemPlantId === selectedProductionPlantId;
                                                        const showEditControls = !isLoaded && isPlantMatched;
                                                        return (
                                                            <div key={index} className={isLoaded ? "card border-success" : (showEditControls ? "card border-secondary" : "card border-info")}>
                                                                {/* Item Header */}
                                                                <div className={isLoaded ? "card-header py-2 px-3 bg-success bg-opacity-10 d-flex justify-content-between align-items-center" : (showEditControls ? "card-header py-2 px-3 bg-light d-flex justify-content-between align-items-center" : "card-header py-2 px-3 bg-info bg-opacity-10 d-flex justify-content-between align-items-center")}>
                                                                    <span className="fw-semibold">{item.product.name}</span>
                                                                    {isLoaded
                                                                        ? <span className="badge bg-success"><FontAwesomeIcon icon={faSquareCheck} className="me-1" />Loaded</span>
                                                                        : <span className="badge bg-warning text-dark">Pending</span>
                                                                    }
                                                                </div>
                                                                {/* Item Body */}
                                                                <div className="card-body py-2 px-3">
                                                                    {!showEditControls ? (
                                                                        <div className="row g-2">
                                                                            <div className="col-6">
                                                                                <div className="small text-muted">Ordered Qty</div>
                                                                                <div className="fw-semibold">{item.quantity} {item.product.unitOfMeasureCode} 
                                                                                    {item.product.unitOfMeasureId != item.product.shippingUnitId &&
                                                                                    ` (${item.packages})`
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-6">
                                                                                <div className="small text-muted">Loaded Qty</div>
                                                                                <div className="fw-semibold text-success">{item.loadingDetails.loadedQuantity} {item.product.unitOfMeasureCode}</div>
                                                                            </div>
                                                                            <div className="col-6">
                                                                                <div className="small text-muted">Batch No.</div>
                                                                                <div className="fw-semibold">{item.batchNumber || '—'}</div>
                                                                            </div>
                                                                            <div className="col-6">
                                                                                <div className="small text-muted">Plant Name</div>
                                                                                <div className="fw-semibold">{item?.product?.plantName || '—'}</div>
                                                                            </div>
                                                                            <div className="col-6">
                                                                                <div className="small text-muted">Loaded By</div>
                                                                                <div className="fw-semibold">{item.loadingDetails.loadedByName || '—'}</div>
                                                                            </div>
                                                                            <div className="col-12">
                                                                                <div className="small text-muted">Loaded At</div>
                                                                                <div className="fw-semibold">{item.loadingDetails.loadedAt ? moment(item.loadingDetails.loadedAt).format('DD MMM YYYY, hh:mm A') : '—'}</div>
                                                                            </div>
                                                                            {!isLoaded && !isPlantMatched && (
                                                                                <div className="col-12">
                                                                                    <div className="badge bg-secondary">Select matching production plant to edit this item.</div>
                                                                                </div>
                                                                            )}
                                                                            {item.loadingDetails.remarks &&
                                                                                <div className="col-12">
                                                                                    <div className="small text-muted">Remarks</div>
                                                                                    <div className="text-secondary">{item.loadingDetails.remarks}</div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <div className="row g-2 align-items-end">
                                                                                <div className="col-6 col-md-4">
                                                                                    <label className="form-label mb-1 small text-muted">Ordered Qty</label>
                                                                                    <div className="fw-semibold">{item.quantity} {item.product.unitOfMeasureCode} 
                                                                                    {item.product.unitOfMeasureId != item.product.shippingUnitId &&
                                                                                    ` (${item.packages})`
                                                                                    }
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-6 col-md-4">
                                                                                    <label htmlFor={`dispatchQty_${index}`} className="form-label mb-1 small text-muted">Dispatch Qty</label>
                                                                                    <input id={`dispatchQty_${index}`} type="number" className="form-control form-control-sm"
                                                                                        min="0" max={item.quantity} step="1" placeholder="Enter qty"
                                                                                        value={item.loadingDetails.currentLoading}
                                                                                        onChange={(e) => {
                                                                                            const value = e.target.value;
                                                                                            setOrder((prev) => {
                                                                                                if (!prev) return prev;
                                                                                                const newItems = [...prev.items];
                                                                                                newItems[index] = { ...newItems[index], loadingDetails: { ...newItems[index].loadingDetails, currentLoading: (Number(value) > item.quantity) ? item.quantity : Number(value) } };
                                                                                                return { ...prev, items: newItems };
                                                                                            });
                                                                                        }} />
                                                                                </div>
                                                                                <div className="col-12 col-md-4">
                                                                                    <label htmlFor={`batchNo_${index}`} className="form-label mb-1 small text-muted">Batch No.</label>
                                                                                    <input id={`batchNo_${index}`} type="text" className="form-control form-control-sm"
                                                                                        placeholder="Batch #"
                                                                                        value={item.batchNumber}
                                                                                        onChange={(e) => {
                                                                                            const value = e.target.value;
                                                                                            setOrder((prev) => {
                                                                                                if (!prev) return prev;
                                                                                                const newItems = [...prev.items];
                                                                                                newItems[index] = { ...newItems[index], batchNumber: value };
                                                                                                return { ...prev, items: newItems };
                                                                                            });
                                                                                        }} />
                                                                                </div>
                                                                                <div className="col-12">
                                                                                    <label className="form-label mb-1 small text-muted">Remarks</label>
                                                                                    <textarea className="form-control form-control-sm" rows={2} value={item.loadingDetails.remarks || ''}></textarea>
                                                                                </div>
                                                                            </div>
                                                                            <div className="d-flex justify-content-end mt-2">
                                                                                {item.loadingDetails.currentLoading > 0
                                                                                    ? <div className="btn btn-sm btn-success" onClick={() => markAsLoaded(item)}><FontAwesomeIcon icon={faSquareCheck} className="me-1" />Mark As Loaded</div>
                                                                                    : <div className="btn btn-sm btn-secondary disabled">Mark As Loaded</div>
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <div className="text-muted">No items found.</div>
                                            )}
                                        </div>
                                    </div>
                                </>
                            }
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <div className="btn btn-sm btn-danger float-start" onClick={() => setScreen('selectOrder')}>Back</div>
                                </div>
                            </div>
                        </>
                    }
                    {screen === 'scanBarcode' &&
                        <>

                            <div className='row'>
                                <div className='col-12'>
                                    <BarcodeScanner onCapture={(barcodes) => onBarcodeCaptured(barcodes)} onAbort={() => setScreen('selectOrder')} options={{ delay: 1000, formats: ['code_128', 'code_39', 'code_93', 'ean_8', 'ean_13', 'upc_a', 'upc_e'] }} />
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <div className="btn btn-sm btn-danger float-start" onClick={() => setScreen('selectOrder')}>Back</div>
                                </div>
                            </div>

                        </>
                    }
                </>
            }
        </div >
    );
};